import { jobOperationNotifier } from '@/ws';
import { waitForNotifierEventFactory } from '@/ws/factories';

export const waitForOperation = waitForNotifierEventFactory(jobOperationNotifier.once.bind(jobOperationNotifier));
